import type { RootState } from 'features/app/store/store';
import { selectActualCallOwnerUserId } from 'features/call/call-base/store';
import { RequesterType } from 'features/call/call-captions/enums';
import type { CaptionRequester } from 'features/call/call-captions/store';
import {
  teamingAcceptingUserIdSelector,
  teamingRequestingUserSelector,
} from 'features/teaming/teaming-base/store';

export const ENDPOINT_CAPTION_USER_ID = 0;

export interface CaptionStatusTarget {
  requesterType: RequesterType;
  userId: number | null;
}

const interpreterUserId = (userId: number | null | undefined) =>
  userId ? userId : null;

/**
 * Status reports are made by the primary VI, so local demand is PrimaryVI and
 * peer demand is TeamingVI. Endpoint has no user id and always sends 0.
 * 0 is not used as a stand-in for a missing interpreter id.
 */
export const toCaptionStatusTarget = (
  state: RootState,
  requester: CaptionRequester
): CaptionStatusTarget => {
  if (requester === 'deafEndpoint') {
    return {
      requesterType: RequesterType.Endpoint,
      userId: ENDPOINT_CAPTION_USER_ID,
    };
  }

  if (requester === 'remoteInterpreter') {
    return {
      requesterType: RequesterType.TeamingVI,
      userId: interpreterUserId(teamingAcceptingUserIdSelector(state)),
    };
  }

  const requestingUserId = teamingRequestingUserSelector(state).id;

  return {
    requesterType: RequesterType.PrimaryVI,
    userId: interpreterUserId(
      requestingUserId || selectActualCallOwnerUserId(state)
    ),
  };
};
